module.exports = __webpack_public_path__ + "static/media/fireplace_img.62a9d8de.png";